import { Controller } from "@hotwired/stimulus"

// The "what pros get" tab list on the home page: each tab shows its preview,
// and the list advances on its own (the bar under the open tab is the timer)
// until somebody clicks one. Arrow keys move between tabs, as a tablist's do.
export default class extends Controller {
  static targets = ["tab", "pane"]
  static values = { interval: { type: Number, default: 9000 } }

  connect() {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return this.halt()

    this.element.style.setProperty("--www-tick", `${this.intervalValue}ms`)
    this.timer = setInterval(() => this.show((this.index + 1) % this.tabTargets.length), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  choose(event) {
    this.halt()
    this.show(this.tabTargets.indexOf(event.currentTarget))
  }

  step(event) {
    const move = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key]
    if (!move) return

    event.preventDefault()
    this.halt()
    const next = (this.index + move + this.tabTargets.length) % this.tabTargets.length
    this.show(next)
    this.tabTargets[next].focus()
  }

  show(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === index))
      tab.tabIndex = i === index ? 0 : -1
    })
    this.paneTargets.forEach((pane, i) => { pane.hidden = i !== index })
  }

  halt() {
    clearInterval(this.timer)
    this.element.classList.add("is-stopped")
  }

  get index() {
    return this.tabTargets.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
  }
}
